
import ChatbotPopUpInfo from "./ChatbotPopUpInfo";

export default ChatbotPopUpInfo;